Object.defineProperty(exports, '__esModule', {
  value: true
});
var models = require('@ds-developer/models');
var _a;
var AA_BRAND_NAME = "AAD";
var AA_BRAND_DISPLAY_NAME = "AA";
var BSM_BRAND_NAME = "BSM";
var BSM_BRAND_DISPLAY_NAME = "BSM";
var BRAND_COLOURS = (_a = {}, _a[models.Brand.Bsm] = "#F9812A", _a[models.Brand.Aad] = "#FFCC00", _a);

// import { EventType } from "@hubcapp/graphql";
var _a$1, _b;
var EventType;
(function (EventType) {
  EventType["Unavailable"] = "UNAVAILABLE";
  EventType["PaidLesson"] = "PAID_LESSON";
  EventType["UnpaidLesson"] = "UNPAID_LESSON";
  EventType["NewLesson"] = "NEW_LESSON";
  EventType["Travel"] = "TRAVEL";
  EventType["Cancelled"] = "CANCELLED";
})(EventType || (EventType = {}));
var SCROLLER_MONTHS_RANGE = 60;
var SCROLLER_ITEM_WIDTH = 55;
var EVENT_TITLES = (_a$1 = {}, _a$1[EventType.NewLesson] = "New", _a$1[EventType.PaidLesson] = "Pre-paid", _a$1[EventType.UnpaidLesson] = "Not paid", _a$1[EventType.Unavailable] = "Unavailable", _a$1[EventType.Travel] = "Travelling time", _a$1[EventType.Cancelled] = "Cancelled", _a$1);
var EVENT_COLORS = (_b = {}, _b[EventType.NewLesson] = {
  highlight: "#4CAF50",
  background: "#F2FFF3"
}, _b[EventType.PaidLesson] = {
  highlight: "#3DC0DB",
  background: "#F2F9FF"
}, _b[EventType.UnpaidLesson] = {
  highlight: "#F9812A",
  background: "#FFECE6"
}, _b[EventType.Unavailable] = {
  highlight: "#B0BEC5",
  background: "#F8F8F9"
}, _b[EventType.Travel] = {
  highlight: "repeating-linear-gradient(-45deg, #888 1px, #888 1px, 2px, transparent 2px, transparent 8px)",
  background: "repeating-linear-gradient(-45deg, #D9D9D9 1px, #D9D9D9 1px, 2px, transparent 2px, transparent 8px)"
}, _b[EventType.Cancelled] = {
  highlight: "#ff1500",
  background: "#ff8a80"
}, _b);
var GENERIC_ERROR_MESSAGE = "Something went wrong, please try again.";
var ERROR_TYPES = {
  INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
  EXPIRED_AUTHENTICATION_CODE: "EXPIRED_AUTHENTICATION_CODE",
  DATABASE_ERROR: "DATABASE_ERROR",
  DEACTIVATED_ACCOUNT: "DEACTIVATED_ACCOUNT",
  CANCELLATION_REASON_TOO_SHORT: "CANCELLATION_REASON_TOO_SHORT",
  LESSON_IN_PAST: "LESSON_IN_PAST"
};
var defaultFormState = {
  isValid: false,
  values: {},
  touched: {},
  errors: {}
};
var SALUTATIONS = ["Mr", "Miss", "Mrs", "Ms"];
var INVOICE_RUN_DAY = 2; // Wednesday, 0 = Monday
var INVOICE_RUN_HOUR = 3; // 3AM, 0 = Midnight

var LANGUAGES = ["Albanian", "Arabic", "Bengali", "British Sign Language", "Bulgarian", "Chinese/Cantonese", "Croatian", "Dutch", "English", "Farsi", "French", "German", "Greek", "Gujerati", "Hindi", "Hungarian", "Italian", "Japanese", "Kanadam", "Lingala", "Malayalam", "Pashto", "Polish", "Portuguese", "Punjabi", "Romanian", "Russian", "Serbian", "Somali", "Spanish", "Swahili", "Tamil", "Telugu", "Turkish", "Urdu", "Vietnamese", "Welsh"];
(function (PaymentOperation) {
  PaymentOperation["ChangeInstructor"] = "CHANGE_INSTRUCTOR";
  PaymentOperation["DitTopUpOrder"] = "DIT_TOP_UP_ORDER";
  PaymentOperation["Miscellaneous"] = "MISCELLANEOUS";
  PaymentOperation["NewFranchise"] = "NEW_FRANCHISE";
  /** This referes specifically to a new DIT learner */
  PaymentOperation["NewLearner"] = "NEW_LEARNER";
  PaymentOperation["NewLearnerWithTopUpOrder"] = "NEW_LEARNER_WITH_TOP_UP_ORDER";
  PaymentOperation["TopUpOrder"] = "TOP_UP_ORDER";
})(exports.PaymentOperation || (exports.PaymentOperation = {}));
var BSM_PAYMENT_GATEWAY_PRODUCT_ID = "BSMInternet6583";
var BSM_PAYMENT_GATEWAY_PRODUCT_ID_HELIX = "BSMCallCentre6575";
var AA_PAYMENT_GATEWAY_PRODUCT_ID = "AADSInternet";
var AA_PAYMENT_GATEWAY_PRODUCT_ID_HELIX = "AADSCallCentre";
var BSM_PAYMENT_GATEWAY_MERCHANT_ID = "275239";
var BSM_PAYMENT_GATEWAY_MERCHANT_ID_HELIX = "275240";
var AA_PAYMENT_GATEWAY_MERCHANT_ID = "275237";
var AA_PAYMENT_GATEWAY_MERCHANT_ID_HELIX = "275238";
var AGENT = "AGENT";
var INSTRUCTOR = "INSTRUCTOR";
var LEARNER = "LEARNER";
var MICROSERVICE = "MICROSERVICE";
var STANDARD = "Standard";
var COMPLAINTS = "Complaints";
var TEAM_LEADER = "Team Leader";
var THEMES = {
  LIGHT: "LIGHT",
  ONE_DARK: "ONE_DARK",
  UNICORN: "UNICORN"
};
exports.AA_BRAND_DISPLAY_NAME = AA_BRAND_DISPLAY_NAME;
exports.AA_BRAND_NAME = AA_BRAND_NAME;
exports.AA_PAYMENT_GATEWAY_MERCHANT_ID = AA_PAYMENT_GATEWAY_MERCHANT_ID;
exports.AA_PAYMENT_GATEWAY_MERCHANT_ID_HELIX = AA_PAYMENT_GATEWAY_MERCHANT_ID_HELIX;
exports.AA_PAYMENT_GATEWAY_PRODUCT_ID = AA_PAYMENT_GATEWAY_PRODUCT_ID;
exports.AA_PAYMENT_GATEWAY_PRODUCT_ID_HELIX = AA_PAYMENT_GATEWAY_PRODUCT_ID_HELIX;
exports.AGENT = AGENT;
exports.BRAND_COLOURS = BRAND_COLOURS;
exports.BSM_BRAND_DISPLAY_NAME = BSM_BRAND_DISPLAY_NAME;
exports.BSM_BRAND_NAME = BSM_BRAND_NAME;
exports.BSM_PAYMENT_GATEWAY_MERCHANT_ID = BSM_PAYMENT_GATEWAY_MERCHANT_ID;
exports.BSM_PAYMENT_GATEWAY_MERCHANT_ID_HELIX = BSM_PAYMENT_GATEWAY_MERCHANT_ID_HELIX;
exports.BSM_PAYMENT_GATEWAY_PRODUCT_ID = BSM_PAYMENT_GATEWAY_PRODUCT_ID;
exports.BSM_PAYMENT_GATEWAY_PRODUCT_ID_HELIX = BSM_PAYMENT_GATEWAY_PRODUCT_ID_HELIX;
exports.COMPLAINTS = COMPLAINTS;
exports.ERROR_TYPES = ERROR_TYPES;
exports.EVENT_COLORS = EVENT_COLORS;
exports.EVENT_TITLES = EVENT_TITLES;
exports.GENERIC_ERROR_MESSAGE = GENERIC_ERROR_MESSAGE;
exports.INSTRUCTOR = INSTRUCTOR;
exports.INVOICE_RUN_DAY = INVOICE_RUN_DAY;
exports.INVOICE_RUN_HOUR = INVOICE_RUN_HOUR;
exports.LANGUAGES = LANGUAGES;
exports.LEARNER = LEARNER;
exports.MICROSERVICE = MICROSERVICE;
exports.SALUTATIONS = SALUTATIONS;
exports.SCROLLER_ITEM_WIDTH = SCROLLER_ITEM_WIDTH;
exports.SCROLLER_MONTHS_RANGE = SCROLLER_MONTHS_RANGE;
exports.STANDARD = STANDARD;
exports.TEAM_LEADER = TEAM_LEADER;
exports.THEMES = THEMES;
exports.defaultFormState = defaultFormState;